import { render, staticRenderFns } from "./WebsiteSwitcherMenu.vue?vue&type=template&id=1d258a4c&"
import script from "./WebsiteSwitcherMenu.vue?vue&type=script&lang=js&"
export * from "./WebsiteSwitcherMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports